<template>
  <div>
    <Row class="expand-row">
      <Col span="24">
         <table style="width: 100%">
           <tr>
             <th>规格</th>
             <th>颜色</th>

             <th>当前库存</th>
             <th>预警下限</th>
           </tr>
           <tr v-for="(k,v) in row.expand" align="center">
             <td>{{k.size}}</td>
              <td>{{k.color}}</td>

             <td>{{k.num}}</td>
             <td>{{k.warning}}</td>
           </tr>
         </table>
      </Col>
    </Row>
  </div>
</template>
<script>
  export default {
    props: {
      row: Object
    }
  };
</script>